import React, { useState } from "react";

import Modal from "react-responsive-modal";

import "./NoticeModal.scss";
import GameBanner from "../Game/Banner";
import useLocalStorage from "../../services/useLocalStorage";
import { Link } from "react-router-dom";
import { NOTICE_SEEN_KEY } from "../../types/GameTypes";

const currentNonce = process.env.REACT_APP_NOTICE_NONCE;

function AppNoticeModal() {
  const [previousNonce, setPreviousNonce] = useLocalStorage(NOTICE_SEEN_KEY, "");

  const [showNotice, setShowNotice] = useState<boolean>(previousNonce !== currentNonce);

  const onHideNotice = () => {
    setShowNotice(false);
  };

  const onDontShowNotice = () => {
    setPreviousNonce(currentNonce);
    setShowNotice(false);
  };

  return (
    <Modal
      open={showNotice}
      onClose={onHideNotice}
      classNames={{ modal: "notice-modal", closeIcon: "closer" }}
    >
      <div className="body">
        <header>
          <h1>
            <GameBanner />
          </h1>
          <h3>What's new?</h3>
        </header>

        <p>Welcome to a new version of BlackBox!</p>

        <p>
          Previous users of BlackBox may notice some user interface tweaks, but the mechanics of the game
          remain the same. (If you are new to the game, please see the <Link to="/guide">Player's Guide</Link>
          .)
        </p>
        <p>
          There <em>are</em> some new features and changes of note:
        </p>
        <ul>
          <li>
            A new "Show Rays" button has been added to completed games so that you can see the paths of{" "}
            <em>all</em> rays that you shot into the black box during the game.
            <br />
            The ability to show an individual ray path remains by clicking on the ports.
          </li>
          <li>The game layout for smaller devices, such as mobile devices, has been improved.</li>
          <li>
            The leaderboard has been extended such that it shows not only top scores, but recent games, and
            games played under your player name. Also, each listed game is a link so you can view the outcome
            of the games!
          </li>
        </ul>

        <p>
          And the best news is that all previous games have been ported to the newly re-vamped database so all
          your existing game bookmarks will still work.
          <br />
          (Although the database <em>did</em> get purged of games for which no player name was given -- that
          cleared the leaderboard of high-scoring games with no player name.)
        </p>
      </div>

      <div className="button-bar">
        <button className="game-button got-it" onClick={onDontShowNotice}>
          Got it!
        </button>
        <button className="game-button" onClick={onHideNotice}>
          Remind me later
        </button>
      </div>
    </Modal>
  );
}

export default AppNoticeModal;
